import { get, post } from '../utils/axios'

export const getHolidayAPI = async (body) => {
  return await get('holiday', body)
}

export const getHolidayTypeAPI = async () => {
  return await get('holiday/type')
}

export const postHolidayAPI = async (body) => {
  return await post('holiday/post', body)
}

export const putHolidayAPI = async (body) => {
  return await post('holiday/put', body)
}

export const cancelHolidayAPI = async (holidayId) => {
    return await post('holiday/cancel', holidayId)
  }
  